var map = {
	"./01_balance.json": "bzx+",
	"./02_order.json": "K1eD",
	"./03_setting.json": "2Cei"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "amGg";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/websocket/account \.json$
// module id = amGg
// module chunks = 3